module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation-bar', [_c('span', {
    slot: "content"
  }, [_vm._v("我的二维码")])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('br'), _vm._v(" "), (_vm.user.barCodeURL) ? _c('img', {
    staticClass: "code-img",
    attrs: {
      "alt": "加载中",
      "src": _vm.user.barCodeURL
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user.userId) ? _c('span', [_vm._v(_vm._s(_vm.user.userId + 131905000911))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user.qrURL) ? _c('img', {
    staticClass: "code-img",
    attrs: {
      "alt": "加载中",
      "src": _vm.user.qrURL
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-footer"
  }, [_c('p', {
    staticClass: "weui-footer__text"
  }, [_vm._v("请出示给导游或商家")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60e86fe0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Card.vue
// module id = 195
// module chunks = 2